<template>
	<div class="w-100 my-5 py-4">
		<loader />
	</div>
</template>
<script>
	import {mapMutations,mapGetters} from 'vuex'
	import moment from 'moment'
	import { get } from '@/services/index.js'

	export default{
		metaInfo(){
      return {title:'Loading...'}
    },
		async mounted(){
			let checkInDate = moment().startOf('day').toDate();
			let checkOutDate = moment().startOf('day').add(this.$defaultFilterBE('night'),'d').toDate();

			const promoCode = this.$route.params.promo_code;

			if (promoCode) {
				try {
					const apiParams = {
						merchant_id: this.getMerchant().id,
						promo_code: promoCode,
					};

					const apiResponse = await get(
						'CORE_HOTEL',
						'promocode-detail',
						apiParams
					);
					const { success, data } = apiResponse.data;

					if (success && data && data.stay_date && data.stay_date.length > 0) {
						let availableDates = [];
						const today = moment().startOf('day');

						data.stay_date.forEach(stay => {
							let current = moment(stay.start_date, 'YYYY-MM-DD').startOf('day');
							let end = moment(stay.end_date, 'YYYY-MM-DD').startOf('day');

							if (current.isBefore(today)) current = today.clone();

							while (current.isSameOrBefore(end)) {
								const dayMap = [
									'stay_sunday',
									'stay_monday',
									'stay_tuesday',
									'stay_wednesday',
									'stay_thursday',
									'stay_friday',
									'stay_saturday'
								];
								const dayName = dayMap[current.day()];

								const isDayValid = stay[dayName] !== false && stay[dayName] !== 0;

								if (isDayValid) {
									const minNight = data.min_night || 1;
									availableDates.push({ date: current.clone(), minNight });
								}
								current.add(1, 'day');
							}
						});

						if (availableDates.length > 0) {
							const currentCheckIn = moment().startOf('day');
							const currentCheckOut = currentCheckIn.clone().add(this.$defaultFilterBE('night'), 'days');

							const availableDateStrings = availableDates.map(o => o.date.format('YYYY-MM-DD'));
							const globalMinNight = data.min_night || 1;

							const isRangeAvailable = (start, lengthNights) => {
								if (lengthNights <= 0) return false;
								let temp = start.clone();
								for (let i = 0; i < lengthNights; i++) {
									if (!availableDateStrings.includes(temp.format('YYYY-MM-DD'))) return false;
									temp.add(1, 'day');
								}
								return true;
							};

							availableDates.sort((a, b) => a.date.valueOf() - b.date.valueOf());
							let fallbackCheckIn = availableDates[0].date.clone();
							let fallbackCheckOut = fallbackCheckIn.clone().add(globalMinNight, 'days');

							for (let i = 0; i < availableDates.length; i++) {
								const candidate = availableDates[i].date;
								if (isRangeAvailable(candidate, globalMinNight)) {
									fallbackCheckIn = candidate.clone();
									fallbackCheckOut = candidate.clone().add(globalMinNight, 'days');
									break;
								}
							}

							const currentNights = currentCheckOut.diff(currentCheckIn, 'days');
							const isCurrentDateValid = isRangeAvailable(currentCheckIn, currentNights);

							if (isCurrentDateValid) {
								if (currentNights < globalMinNight) {
									const newCheckOut = currentCheckIn.clone().add(globalMinNight, 'days');
									if (isRangeAvailable(currentCheckIn, globalMinNight)) {
										checkInDate = currentCheckIn.toDate();
										checkOutDate = newCheckOut.toDate();
									} else {
										checkInDate = fallbackCheckIn.toDate();
										checkOutDate = fallbackCheckOut.toDate();
									}
								}
							} else {
								checkInDate = fallbackCheckIn.toDate();
								checkOutDate = fallbackCheckOut.toDate();
							}
						}
					}
				} catch (error) {
					console.log('ERROR in loading promo date BeDirectPromo: ', error);
				}
			}

			let params = {
				date: {
					check_in: checkInDate,
					check_out: checkOutDate,
				},
				guest: {
					adult: this.$defaultFilterBE('adult'),
					child: 0,
					infant: 0,
				},
				promo_code: promoCode
			}
			this.setBeFilter(params)
			this.resetBECart()
			this.setBeSortBy('room_type')
			this.setBeFilterDetail({
				type: 'room_type',
				data: {}
			})
			this.$router.push({
				name : 'BERoom'
			})
		},
		methods:{
			...mapMutations(['setBeFilter','resetBECart','setBeSortBy','setBeFilterDetail']),
			...mapGetters(['getMerchant'])
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/hotel/be/BeDirectPromo.vue